import type { ButtonHTMLAttributes } from 'react';

import { Icon } from '@/components/Icon/Icon';

import styles from './TrashButton.module.css';

export interface TrashButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> {
  /** The accessible name, e.g. "Delete payslip.pdf". */
  label: string;
}

/** A round red trash can for deleting the thing it sits beside. */
export function TrashButton({ label, className, ...rest }: TrashButtonProps) {
  return (
    <button
      type="button"
      {...rest}
      aria-label={label}
      title={label}
      className={[styles.button, className].filter(Boolean).join(' ')}
    >
      <Icon name="trash" size="1.15rem" />
    </button>
  );
}
